import '@angular/platform-browser-dynamic';
import '@angular/platform-browser';
import '@angular/core';
import '@angular/http';
import '@angular/router';

import 'jquery/src/jquery';
import 'ng2-bootstrap/components/collapse';
import 'bootstrap/dist/js/bootstrap';
//import './node_modules/bootstrap/dist/css/bootstrap.css';
//import './node_modules/bootstrap/dist/css/bootstrap-theme.css';

import './css/bootstrap.css';
import './css/bootstrap-theme.css';
import './app/rtimeapp.css';
import './app/contactus/contactus.css';
import './app/contactus/toaster.css';
//import './css/font-awesome.css';




/** WEBPACK FOOTER **
 ** ./src/vendor.ts
 **/